import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, take, tap } from "rxjs/operators";

import { Store } from "@ngrx/store";
import { LoadMessages } from "../store/messages.actions";
import { MessagesState } from "../store/messages.reducer";
import { MessageModel } from "../models";
import { MessagesService } from "./messages.lib.service";
import { NotificationService } from "libs/tm-common/src/lib/services";
@Injectable({
	providedIn: 'root'
})
export class MessagesResolver {
	private messageService = inject(MessagesService);
	private notificationService = inject(NotificationService);
	private store = inject<Store<MessagesState>>(Store);


	resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<MessageModel[]> {
		return this.messageService.getMessages(route.params.id).pipe(
			take(1),
			tap((messages: MessageModel[]) =>
				this.store.dispatch(new LoadMessages({ messages: messages }))
			),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolveMessagesError", "", 5000);
				return of([]); //Open route, even if media files could not be loaded
			})
		);
	}
}
